/** Enumeraciones de estados compartidas (spec §5). */
export const ROLES = ['DUENO', 'RECEPCION', 'BARBERO'] as const;
export type Rol = (typeof ROLES)[number];

export const ESTADOS_CITA = [
  'agendada',
  'en_tolerancia',
  'en_servicio',
  'por_cobrar',
  'finalizada',
  'cancelada',
  'no_show',
] as const;
export type EstadoCita = (typeof ESTADOS_CITA)[number];
/** Estados que ocupan el horario del barbero. */
export const ESTADOS_CITA_ACTIVOS: readonly EstadoCita[] = ['agendada', 'en_tolerancia', 'en_servicio'];

export const ETIQUETAS_ESTADO_CITA: Record<EstadoCita, string> = {
  agendada: 'Agendada',
  en_tolerancia: 'En espera',
  en_servicio: 'En servicio',
  por_cobrar: 'Por cobrar',
  finalizada: 'Finalizada',
  cancelada: 'Cancelada',
  no_show: 'No se presentó',
};

export const ESTADOS_VENTA = ['abierta', 'por_cobrar', 'suspendida', 'pagada', 'cancelada'] as const;
export type EstadoVenta = (typeof ESTADOS_VENTA)[number];

export const ESTADOS_TURNO_CAJA = ['abierto', 'bloqueado', 'cerrado'] as const;
export type EstadoTurnoCaja = (typeof ESTADOS_TURNO_CAJA)[number];

export const TIPOS_ARQUEO = ['apertura', 'corte', 'cierre', 'reposicion'] as const;
export type TipoArqueo = (typeof TIPOS_ARQUEO)[number];

export const ESTADOS_DIFERENCIA = [
  'pendiente',
  'repuesto',
  'descontado',
  'perdonado',
  'retirado',
  'corregido',
] as const;
export type EstadoDiferencia = (typeof ESTADOS_DIFERENCIA)[number];

export const METODOS_PAGO = ['efectivo', 'transferencia', 'tarjeta'] as const;
export type MetodoPago = (typeof METODOS_PAGO)[number];

export const ESTADOS_APROBACION = ['pendiente', 'aprobada', 'rechazada', 'expirada'] as const;
export type EstadoAprobacion = (typeof ESTADOS_APROBACION)[number];

export const TIPOS_APROBACION = [
  'promocion',
  'desbloqueo_caja',
  'cambio_margen',
  'asignacion_vacaciones',
  'devolucion',
] as const;
export type TipoAprobacion = (typeof TIPOS_APROBACION)[number];

export const BOLSAS_INVENTARIO = ['venta', 'uso'] as const;
export type BolsaInventario = (typeof BOLSAS_INVENTARIO)[number];

export const TIPOS_MOVIMIENTO = [
  'compra',
  'venta',
  'reserva',
  'liberacion',
  'consumo',
  'ajuste',
  'devolucion',
  'transferencia',
] as const;
export type TipoMovimiento = (typeof TIPOS_MOVIMIENTO)[number];

export const CATEGORIAS_GASTO = ['renta', 'insumos', 'compra_productos', 'sueldos', 'servicios', 'herramientas', 'ferreteria', 'otro'] as const;
export type CategoriaGasto = (typeof CATEGORIAS_GASTO)[number];
